import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body pb-0" }
const _hoisted_2 = { class: "d-flex align-items-center mb-3" }
const _hoisted_3 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_4 = { class: "symbol symbol-45px me-5" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_7 = { class: "text-gray-400 fw-bold" }
const _hoisted_8 = { class: "my-0" }
const _hoisted_9 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "mb-7" }
const _hoisted_12 = { class: "text-gray-800 mb-5" }
const _hoisted_13 = { class: "d-flex align-items-center mb-5" }
const _hoisted_14 = {
  key: 0,
  class: "btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4"
}
const _hoisted_15 = { class: "svg-icon svg-icon-3" }
const _hoisted_16 = {
  key: 1,
  class: "btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4"
}
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = {
  key: 0,
  class: "m-5 mb-5 notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_19 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, " Este ticket aun no ha sido respondido. ")
  ])
], -1)
const _hoisted_21 = {
  key: 1,
  class: "mb-7 ps-10"
}
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "symbol symbol-45px me-5" }
const _hoisted_24 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_25 = { class: "d-flex align-items-center flex-wrap mb-1" }
const _hoisted_26 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bolder me-2"
}
const _hoisted_27 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_28 = { class: "text-gray-800 fs-7 fw-normal pt-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown2 = _resolveComponent("Dropdown2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_avatar, {
              size: "30",
              fullname: _ctx.currentTicket.contactoNombre,
              color: "#c0c0c0"
            }, null, 8, ["fullname"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.currentTicket.contactoNombre), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.currentTicket.fechaTicket)), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.currentTicket.contactoEmail), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown2)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentTicket.comentario), 1),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.currentTicket.respondido)
            ? (_openBlock(), _createElementBlock("a", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
                ]),
                _createTextVNode(" 1 ")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.currentTicket.respondido)
            ? (_openBlock(), _createElementBlock("a", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
                ]),
                _createTextVNode(" 0 ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.currentTicket.respondido)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
            ]),
            _hoisted_20
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentTicket.respondido)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_avatar, {
                  size: "30",
                  fullname: _ctx.currentTicket.usuarioRespuesta,
                  color: "#005E8A"
                }, null, 8, ["fullname"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.currentTicket.usuarioRespuesta), 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatDate(_ctx.currentTicket.fechaRespuesta)), 1)
                ]),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.currentTicket.respuesta), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_29
    ])
  ], 2))
}